import { render, staticRenderFns } from "./DomainReviewTable.vue?vue&type=template&id=d125f8dc&scoped=true"
import script from "./DomainReviewTable.vue?vue&type=script&lang=js"
export * from "./DomainReviewTable.vue?vue&type=script&lang=js"
import style0 from "./DomainReviewTable.vue?vue&type=style&index=0&id=d125f8dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d125f8dc",
  null
  
)

export default component.exports